// Contracts — participant reference photo (#62). The moderator captures ONE
// optional photo per child AT THE SHOOT (not on the parent/landing forms) and
// staff view it in the pack (отгрузка) participant picker. Client downscales to
// a small JPEG dataURL (maxSide 640, q 0.7) and POSTs it; the worker decodes to
// R2 (KIDS_CLIPS) and stamps children.photo_key. The GET stream lives in
// participant_photo.ts (staff-authed by child id). The photo bytes are PII — the
// worker never logs them (secrets.md).
import { z } from 'zod';

// POST /api/kids/participant-photo/:childId (staff) — body.photo is a downscaled
// `data:image/…;base64,…` dataURL. Capped at 2MB of base64 so a rogue payload
// can't balloon the request; a 640px JPEG dataURL is well under that.
export const KidsParticipantPhotoReqSchema = z.object({
  photo: z.string().max(2_000_000),
});
export type KidsParticipantPhotoReq = z.infer<typeof KidsParticipantPhotoReqSchema>;

// On success the child now has a photo (hasPhoto=true drives the picker thumb).
export const KidsParticipantPhotoResSchema = z.object({
  ok: z.literal(true),
  hasPhoto: z.literal(true),
});
export type KidsParticipantPhotoRes = z.infer<typeof KidsParticipantPhotoResSchema>;
